export default __webpack_public_path__ + "static/media/NFD_Minting_Guide1024_10.e4474b00.png";